// Landing page registered at "/". Renders a branded hub with cards linking
// to the three main areas of the portal: Create, Catalog, and Docs.
// Replaces the previous Navigate redirect to /create.

import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { makeStyles } from '@material-ui/core';
import { Link } from '@backstage/core-components';

const useStyles = makeStyles({
  page: {
    padding: '48px 56px',
    maxWidth: 900,
  },
  heading: {
    margin: 0,
    fontSize: '2rem',
    fontWeight: 700,
    color: '#FF286E',
    letterSpacing: '0.01em',
  },
  subtitle: {
    marginTop: 8,
    marginBottom: 48,
    fontSize: '1rem',
    color: 'rgba(255,255,255,0.6)',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: 24,
  },
  card: {
    backgroundColor: '#0A1128',
    borderRadius: 8,
    padding: '28px 24px',
    border: '1px solid rgba(255,255,255,0.08)',
    textDecoration: 'none',
    display: 'block',
    transition: 'border-color 0.15s, box-shadow 0.15s',
    '&:hover': {
      borderColor: 'rgba(255,40,110,0.5)',
      boxShadow: '0 0 0 1px rgba(255,40,110,0.2)',
      textDecoration: 'none',
    },
  },
  cardIcon: {
    fontSize: '1.8rem',
    marginBottom: 12,
    display: 'block',
  },
  cardTitle: {
    margin: 0,
    fontSize: '1.1rem',
    fontWeight: 700,
    color: '#FFFFFF',
    marginBottom: 8,
  },
  cardDesc: {
    margin: 0,
    fontSize: '0.875rem',
    color: 'rgba(255,255,255,0.55)',
    lineHeight: 1.5,
  },
});

const HomePage = () => {
  const classes = useStyles();
  return (
    <div className={classes.page}>
      <h1 className={classes.heading}>Silk.Shuttle</h1>
      <p className={classes.subtitle}>
        Silk GTM demo environment — developer portal
      </p>
      <div className={classes.grid}>
        <Link
          to="/create/templates?filters%5Bkind%5D=template&filters%5Btags%5D=demo&filters%5Buser%5D=all"
          className={classes.card}
          underline="none"
        >
          <span className={classes.cardIcon}>⚡</span>
          <h2 className={classes.cardTitle}>Create</h2>
          <p className={classes.cardDesc}>
            Run automation workflows — ETL jobs, data loads, and end-to-end demo
            orchestration.
          </p>
        </Link>
        <Link to="/catalog" className={classes.card} underline="none">
          <span className={classes.cardIcon}>📦</span>
          <h2 className={classes.cardTitle}>Catalog</h2>
          <p className={classes.cardDesc}>
            Browse demo environment components, systems, APIs, and teams.
          </p>
        </Link>
        <Link to="/docs-home" className={classes.card} underline="none">
          <span className={classes.cardIcon}>📖</span>
          <h2 className={classes.cardTitle}>Docs</h2>
          <p className={classes.cardDesc}>
            Portal guides, infrastructure runbooks, and template documentation.
          </p>
        </Link>
      </div>
    </div>
  );
};

const homePage = PageBlueprint.make({
  name: 'home',
  params: {
    path: '/',
    noHeader: true,
    loader: async () => <HomePage />,
  },
});

export const homeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [homePage],
});
